import React from 'react';
import Hero from '../components/home/Hero';
import HowItWorks from '../components/home/HowItWorks';
import CertifiedZigzag from '../components/home/CertifiedZigzag';
import FeaturedDocs from '../components/home/FeaturedDocs';
import KeyFigures from '../components/home/KeyFigures';
import LanguagesSection from '../components/home/LanguagesSection';
import QuoteNeed from '../components/home/QuoteNeed';
import WhyChooseUs from '../components/home/WhyChooseUs';
import ReviewsSection from '../components/home/ReviewsSection';
import CTASection from '../components/home/CTASection';

export default function HomePage() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <CertifiedZigzag />
      <FeaturedDocs />
      <QuoteNeed />

     {/** <WhatWeDo />*/} 
      <LanguagesSection />
      <WhyChooseUs />
      <KeyFigures />
      <ReviewsSection />
      <CTASection />
    </>
  );
}
